var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({
      background: `rgba(0, 0, 0, 0.75) url(${_vm.image})`,
      backgroundBlendMode: `overlay`,
      backgroundSize: 'cover',
    })},[_c('div',{staticClass:"container d-flex fd-column:mo p-x-2:mo SECTION"},[_c('div',{staticClass:"HEADER-INFO"},[_c('h1',[_vm._v(_vm._s(_vm.content.title))]),_c('p',{staticClass:"p-b-4 h5"},[_vm._v(_vm._s(_vm.content.description))]),_c('a',{attrs:{"href":this.$runtimeConstants.SALESFORCE_BECOME_A_PRO+_vm.href}},[_c('button',{staticClass:"BUTTON btn"},[_vm._v(" "+_vm._s(_vm.content.cta)+" ")])])]),_c('div',{staticClass:"p-y-4"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }